import appSettings from '../../package.json';

export const environment = {
  production: true,
  appVersion: appSettings.version + '-dev',
  apiUrl: 'https://ogibio-api-dev.azurewebsites.net/api/v1',
  intercomAppId: 'mtuxd90s',
  name: 'DEV',
};
